import {getDateFromIsoString} from '@shared/api';
import {getLocalizedText} from '@shared/utils';
import {
  EventTemplate,
  TemplateParameterValue,
  Video,
  VideoEventSchedule,
} from '../types';
import {
  EventTemplateOnBackend,
  TemplateParameterValueOnBackend,
  VideoEventScheduleOnBackend,
  VideoOnBackend,
} from './backendTypes';

export const mapVideoFromBackend = ({
  id,
  video_url,
  name,
  channel,
}: VideoOnBackend): Video => ({
  id,
  videoUrl: video_url,
  name,
  channel,
});

export const mapTemplateParameterValueFromBackend = ({
  id,
  name,
  channel,
}: TemplateParameterValueOnBackend): TemplateParameterValue => ({
  id,
  name,
  channel,
});

export const mapEventTemplateFromBackend = ({
  id,
  type,
  templates,
}: EventTemplateOnBackend): EventTemplate => ({
  id,
  type,
  name: getLocalizedText(templates?.name) || type,
});

export const mapVideoEventScheduleFromBackend = ({
  id,
  video_id,
  video_name,
  template_id,
  template_type,
  cron,
  duration_minutes,
  next_run_at,
}: VideoEventScheduleOnBackend): VideoEventSchedule => ({
  id,
  videoId: video_id,
  videoName: video_name,
  templateId: template_id,
  templateType: template_type,
  cron,
  durationMinutes: duration_minutes,
  nextRunAt: getDateFromIsoString(next_run_at),
});
